import { useQuery } from "@tanstack/react-query"
import { AXIOS_API_INSTANCE } from "../../Constants";
import { send_authorized_request } from "../../Constants/cognito";

export const useUsers = () => {
    // const queryClient = useQueryClient();
    const query = useQuery({
        queryKey: ["userList"],
        staleTime: 1000 * 60 * 30, // 30 minutes
        queryFn: async () => {
            try {
                const response = await AXIOS_API_INSTANCE.get('/users', {
                    params: {
                        order_by: 'name',
                        order_direction: 'asc',
                        include_location_ids: true,
                    }
                })
                return response.data.data
            } catch (error) {
                if (error.response.status === 401) {
                    send_authorized_request()
                }
                throw new Error('Network response was not ok')
            }
        },
        retry: 1,
        placeholderData: []
    })

    return {
        ...query,
        deleteItem: null,
        addItem: null,
        updateItem: null
    }
}

export const findUser = (users, user_id) => {
    return (users ?? []).find((u) => u.id === user_id)
}

export const build_users_list = (users, my_user, include_deactivated = false, include_unassigned = true, prioritize_service_technicians = false, prioritized_location = 'all') => {
    let return_list = []
    let users_list = users ?? []
    if (include_unassigned) {
        return_list.push({ name: "Unassigned", id: -1 })
    }
    if (!include_deactivated) {
        users_list = users_list.filter((x) => !x.deactivated)
    }
    return_list = return_list.concat(
        (users_list).map(
            (u) => {
                if (u.id === my_user.id) {
                    return { ...u, name: u.name + " (me)" }
                } else if (prioritize_service_technicians && u.permissions_service_tech) {
                    return { ...u, name: u.name + " (Technician)" }
                } else {
                    return { ...u }
                }
            }
        ).sort((a, b) => {
            if (a.id === my_user.id) {
                return -1
            }
            if (b.id === my_user.id) {
                return 1
            }

            if (a.name === "Profit Max Pro Admin") {
                return 1
            } else if (b.name === "Profit Max Pro Admin") {
                return -1
            }
            if (prioritized_location !== 'all') {
                if (a.location_ids?.includes(prioritized_location) && !b.location_ids?.includes(prioritized_location)) {
                    return -1
                } else if (!a.location_ids?.includes(prioritized_location) && b.location_ids?.includes(prioritized_location)) {
                    return 1
                }
            }

            if (prioritize_service_technicians && a.permissions_service_tech && !b.permissions_service_tech) {
                return -1
            } else if (prioritize_service_technicians && !a.permissions_service_tech && b.permissions_service_tech) {
                return 1
            }

            return a.name.localeCompare(b.name)
        })
    )
    return return_list
}